export default __webpack_public_path__ + "static/media/logo_km.ace4565b.png";